// src/components/shared/Header.tsx
import { Link } from "react-router-dom";

interface HeaderProps {
  variant?: "default" | "transparent";
  showNavigation?: boolean;
}

export default function Header(_props: HeaderProps) {
  return (
    <Link
      to="/"
      aria-label="Back to home"
      style={{
        position: "fixed",
        top: "20px",
        left: "24px",
        zIndex: 50,
        width: "36px",
        height: "36px",
        borderRadius: "50%",
        border: "1px solid rgba(255,255,255,0.15)",
        background: "rgba(0,0,0,0.4)",
        backdropFilter: "blur(8px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textDecoration: "none",
        transition: "border-color 0.2s",
      }}
      onMouseEnter={(e) =>
        ((e.currentTarget as HTMLElement).style.borderColor =
          "rgba(255,255,255,0.5)")
      }
      onMouseLeave={(e) =>
        ((e.currentTarget as HTMLElement).style.borderColor =
          "rgba(255,255,255,0.15)")
      }
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        {/* Mushroom cap */}
        <path
          d="M8 2C5.2 2 3 4.0 3 6.5C3 7.5 3.4 8.4 4.1 9H11.9C12.6 8.4 13 7.5 13 6.5C13 4.0 10.8 2 8 2Z"
          fill="rgba(255,255,255,0.7)"
        />
        {/* Mushroom stem */}
        <rect x="6" y="9" width="4" height="5" rx="1.5" fill="rgba(255,255,255,0.5)" />
        {/* Dots on cap */}
        <circle cx="6.5" cy="5.5" r="0.8" fill="rgba(0,0,0,0.3)" />
        <circle cx="9.5" cy="4.5" r="0.8" fill="rgba(0,0,0,0.3)" />
        <circle cx="8" cy="6.5" r="0.6" fill="rgba(0,0,0,0.25)" />
      </svg>
    </Link>
  );
}
